import type { IHttpApi } from '@cian/http-api';
import type { ILogger } from '@cian/logger/shared';

import {
  fetchFindSearchCatalogItems,
  type TFindSearchCatalogItemsResponse,
} from 'shared/common/repositories/geo/v1/find-search-catalog-items';

export interface IGeoRegionItem {
  id: number;
  displayName: string;
  parentId: number | null;
}

interface IParams {
  httpApi: IHttpApi;
  logger: ILogger;
  text: string;
}

function isHttpErrorResponse(value: unknown): value is { statusCode: number } {
  return (
    typeof value === 'object' &&
    value !== null &&
    'statusCode' in value &&
    typeof (value as { statusCode: unknown }).statusCode === 'number'
  );
}

export async function searchRegions({ httpApi, logger, text }: IParams): Promise<IGeoRegionItem[]> {
  const result = (await fetchFindSearchCatalogItems({
    httpApi,
    parameters: { text },
  })) as TFindSearchCatalogItemsResponse;

  if (isHttpErrorResponse(result) && result.statusCode !== 200) {
    const err = new Error(`find-search-catalog-items failed with status ${result.statusCode}`);
    logger.error(err);
    throw err;
  }

  const response = (
    result as { response?: { items?: Array<{ id: number; displayName: string; parentId?: number | null }> } }
  ).response;
  const items = response?.items ?? [];

  return items.map(item => ({
    id: item.id,
    displayName: item.displayName,
    parentId: item.parentId ?? null,
  }));
}
